import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import photoCyprien from "../assets/img/photo-cyprien.png";

export const About = () => {
  return (
    <section className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950 text-gray-900 dark:text-gray-100 p-6 transition-colors">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="flex flex-col items-center space-y-6 max-w-2xl w-full"
      >
        {/* photo */}
        <img
          src={photoCyprien}
          alt="Cyprien Conseillon"
          className="w-40 h-40 rounded-full object-cover shadow-lg ring-2 ring-orange-100 dark:ring-orange-900/40"
        />

        {/* Titre */}
        <h1 className="text-3xl font-bold text-orange-600 dark:text-orange-400 text-center">
          À propos de moi
        </h1>

        {/* Texte */}
        <div className="text-center text-gray-700 dark:text-gray-300 space-y-6">
          <p className="text-lg">
            Je m'appelle <span className="font-semibold text-gray-900 dark:text-gray-100">Cyprien</span>, coach au club{" "}
            <span className="font-semibold text-gray-900 dark:text-gray-100">Enfants du Forez de Feurs</span>.
          </p>
          <p className="text-lg">
            Passionné de <span className="italic">basketball</span> depuis toujours, j'ai décidé de me former en autodidacte pour créer ce projet :{" "}
            <span className="font-semibold text-gray-900 dark:text-gray-100">SwishData</span>.
          </p>
          <p className="text-lg">
            Mon objectif est d'offrir une plateforme simple et intuitive pour suivre, analyser et faire progresser les performances des joueurs 🏀📈.
          </p>
        </div>

        {/* Bouton retour */}
        <Link
          to="/"
          className="mt-2 bg-orange-600 hover:bg-orange-700 text-white py-3 px-6 rounded-lg transition-colors
                     focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-400"
        >
          Retour à l'accueil
        </Link>
      </motion.div>
    </section>
  );
};
